import React from "react";

import { Link, withRouter } from "react-router-dom";
import Amplify, { Auth } from "aws-amplify";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
// import * as Modal from 'react-modal';
// import SignatureCanvas from 'react-signature-canvas';
import PropTypes from "prop-types";

import * as SecretKeys from "../../ENV.json";
import "react-phone-number-input/style.css";
import "react-responsive-ui/style.css";
import Header from "../Header/header";

import SignatureComponent from "../common/signatureComponent";
import loader from "../../images/Spin-1s-107px.gif";

import {
  saveBusinessUser,
  saveBusinessUserStep1,
  saveConsumerUser,
  getAllCountry,
  getAllStates,
  getCityByStateId,
  getAllPlans,
  getAffiliateDetailByAffiliateKey,
  confirmUserEmail,
  clearData,
  getBusiness,
  getIndustry,
  checkEmailVerify,
  getPageData,
  requestApiData,
  clearDataEmail
} from "../../Actions/actions";
// import CustomSignature from './customSignature';
import TextFieldGroup from "../common/TextFieldGroup";

Amplify.configure(SecretKeys.awsUserpool);

class Signup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      firstName: "",
      lastName: "",
      password: "",
      passwordType: "password",
      companyTitle: "",
      mobilePhone: "",
      workPhoneNumber: "",
      email: "",
      companyName: "",
      streeAddress: "",
      city: "",
      state: "",
      zipCode: "",
      separateTaxId: "",
      enterpriseType: "",
      startingYear: "",
      webSite: "",
      industryTypeId: "",
      taxId: "",
      errors: {},
      cognitoClientId: "",
      bankruptcyStatus: "",
      dissolvedStatus: "",
      acceptCC: "",
      planPriceId: 0,
      isLoading: false,
      businessTypeId: "",
      roleName: "Business-User",
      IsCompanyForm: 1,
      // defaultIndexSignC: 1,
      readDisclaimer: "",
      readPrivacyPolicy: "",
      readLetterOfAgency: "",
      readUserAgreement: "",
      errorsCompany: {},
      errorsTermPolicy: {},
      modalIsOpen: false,
      fileError: false,
      totalTaxId: 1,
      file: "",
      code: "",
      indicatorBusiness: "",
      indicatorConsumer: "",
      signatureImageContentType: "image/png",
      signatureImageFileSize: "",
      errorForcodeverify: false,
      isMounted: false,
      affiliateId: "",
      partnerType: "",
      defaultIndex: 1,
      countryCode: "+1",
      workCountryCode: "+1",
      cityId: "",
      nonWorkPhoneNumber: "",
      showTab: 1,
      affiliateKeyId: "",
      isLoginCheckS: false,
      plansDataAffiliate1: [],
      indexType: "defaultIndex",
      passwordColor: "black",
      cchangeSignature: 0,
      signatureDefaultValue: "",
      signatureFontFamily: "",
      emptyErrorSign: 1,
      AllPlansForMember1: [],
      intervalId: 0,
      pageType: "business",
      enableButtonT: true,
      userDataLogin1: [],
      isLoader: false,
      BusinessUserDataStep1Data: {},
      cFirstName: "",
      cLastName: "",
      cState: "",
      cSince: "",
      cEmployer: "",
      cEmail: "",
      cPhone: "",
      cPassword: "",
      cNotification: "",
      cUpdateClaim: "",
      serviceFeeAgree: "",
      bankAccount: "",
      otherIndustryType: "",
      selectedPlanName: "",
      selectedPlanAmount: "",
      paymentStatus: "pending"
    };
    this.onChange = this.onChange.bind(this);
    this.onChangeTaxId = this.onChangeTaxId.bind(this);
    this.onChange1 = this.onChange1.bind(this);
    // this.validateInput = this.validateInput.bind(this);
    // this._onSelect = this._onSelect.bind(this);
    // this._onSelectForBusiness = this._onSelectForBusiness.bind(this);
    // this._onSelectForYears = this._onSelectForYears.bind(this);
    this.AckOnchange = this.AckOnchange.bind(this);
    this.openModal = this.openModal.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.finalSubmit = this.finalSubmit.bind(this);
    this.uploadHandler = this.uploadHandler.bind(this);
    this.onPlanSelect = this.onPlanSelect.bind(this);
    this.codeOnSubmit = this.codeOnSubmit.bind(this);
    this._citySelect = this._citySelect.bind(this);
    this._cSince1 = this._cSince1.bind(this);
    this._countrySelect = this._countrySelect.bind(this);
    this._countrySelectWork = this._countrySelectWork.bind(this);
    this.onPlanSelectSubmit = this.onPlanSelectSubmit.bind(this);
    this.verifyEmail = this.verifyEmail.bind(this);
    this.onPlanSelectBar = this.onPlanSelectBar.bind(this);
    this.handleDataChidData = this.handleDataChidData.bind(this);
    // this.viewPassword = this.viewPassword.bind(this);
    this.backClick = this.backClick.bind(this);
  }

  handleDataChidData(data) {
    this.setState({
      showTab: data
    });
  }

  async componentWillMount() {
    const intervalId = setInterval(
      this.scrollStep.bind(this),
      this.props.delayInMs
    );
    this.setState({ intervalId });
  }

  handleSaveData = langValue => {
    this.setState({
      readDisclaimer: langValue.readDisclaimer,
      readPrivacyPolicy: langValue.readPrivacyPolicy,
      readLetterOfAgency: langValue.readLetterOfAgency,
      readUserAgreement: langValue.readUserAgreement,
      IsCompanyForm: 5
    });
    const intervalId = setInterval(
      this.scrollStep.bind(this),
      this.props.delayInMs
    );
    this.setState({ intervalId });
  };

  scrollStep = () => {
    if (window.pageYOffset === 0) {
      clearInterval(this.state.intervalId);
    }
    window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
  };

  backClick() {
    const { history } = this.props;
    history.push({ pathname: "/signup-terms-condition" });
    //    this.setState(state => ({
    //      IsCompanyForm: state.IsCompanyForm - 1,
    //    }));
    window.scrollTo(0, 0);
  }

  _citySelect(e) {
    this.setState({ cityId: e.value });
  }

  _countrySelect(e) {
    this.setState({ countryCode: e.value });
  }

  _countrySelectWork(e) {
    this.setState({ workCountryCode: e.value });
  }

  _cSince1(e) {
    this.setState({ startingYear: e.value, errors: {} });
  }

  componentDidMount() {
    this.props.getPageData(7);

    //  this.setState({
    //    intervalId1: 0,
    //  });

    this.setState({ isMounted: true }, () => {
      if (this.state.isMounted) {
        this.setState({ isMounted: false });
        {
          const dataB = {
            lookupTypeId: 1
          };
          const dataI = {
            lookupTypeId: 2
          };

          this.props.getAllStates();
          this.props.getAllCountry();
          this.props.getAllPlans({
            pageNumber: 0,
            pageSize: 20,
            searchKeyword: "",
            planUserType: "Business",
            userId: 0,
            affiliateKey:
              this.props.match.params.affiliateKey !== undefined
                ? this.props.match.params.affiliateKey
                : ""
          });
          this.props.getBusiness(dataB);
          this.props.getIndustry(dataI);
        }
      }
    });
  }

  //  async componentWillMount() {
  //    const affiliateKeyId = this.props.match.params.affiliateKey;
  //    if (affiliateKeyId !== '' && affiliateKeyId !== undefined) {
  //      this.setState({ indexType: 'selectedIndex', isLoader: true });
  //      await this.props.getAffiliateDetailByAffiliateKey(affiliateKeyId);
  //    }
  //    this.setState({ affiliateKeyId });
  //  }

  //  _onSelect(e) {
  //    this.setState({ state: e.target.value });
  //  }

  //  _onSelectForBusiness(e) {
  //    this.setState({ businessTypeId: e.value });
  //  }

  //  _onSelectForYears(e) {
  //    this.setState({ industryTypeId: e.value });
  //  }

  onChangeTaxId(e) {
    const re = /^[0-9\b]+$/;
    if (re.test(e.target.value) || e.target.value === "") {
      if (Number.parseInt(e.target.value, 10) !== 0 || e.target.value === "") {
        this.setState({
          [e.target.name]: e.target.value,
          errors: {},
          errorsTermPolicy: {},
          errorsCompany: {}
        });
      }
    }
  }

  onChange(e) {
    this.setState({
      [e.target.name]: e.target.value,
      errors: {},
      errorsTermPolicy: {},
      errorsCompany: {}
    });
    //  this.setState({ [e.target.name]: e.target.value }, () => { if (this.state.email !== '') { this.props.checkEmailVerify({ email: this.state.email }); } });
    if (e.target.name === "enterpriseType") {
      if (e.target.value === "E") {
        this.setState({ modalIsOpen: true });
      }
    }

    this.setState({ passwordColor: "black" });
    if (e.target.name === "separateTaxId") {
      if (e.target.value === "no") {
        this.setState({ totalTaxId: 0 });
      } else {
        this.setState({ totalTaxId: 1 });
      }
    }
  }

  onChange1(e) {
    this.setState({ passwordColor: "black" });
    //  const re = /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/;
    //  if (re.test(e.target.value) || e.target.value === '') {
    this.setState({
      [e.target.name]: e.target.value.trimLeft(),
      errors: {},
      errorsTermPolicy: {}
    });
    //  }
  }

  onPlanSelectBar(id) {
    this.setState({
      planPriceId: id
    });
    this.onPlanSelectSubmit();
  }

  onPlanSelect(e) {
    const id = e.value;
    this.setState({
      planPriceId: id
    });
  }

  onPlanSelectSubmit() {
    const { history } = this.props;
    const partnerType = this.props.match.params.partnerType;
    if (partnerType === "Both" || typeof partnerType === "undefined") {
      history.push("/signup-terms-condition");
      //  this.setState({
      //    IsCompanyForm: 4,
      //    defaultIndex: 1,
      //  });
      //  scrollToComponent(this.termsAndConditionsRef, {
      //    offset: 0, align: 'bottom', duration: 500, ease: 'inExpo',
      //  });
    } else if (partnerType === "Business") {
      this.setState({
        IsCompanyForm: 1,
        defaultIndex: 1
      });
    } else if (partnerType === "Consumer") {
      this.setState({
        IsCompanyForm: 1,
        defaultIndex: 0
      });
    }
  }

  AckOnchange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  topScreen = () => {
    const intervalId = setInterval(
      this.scrollStep.bind(this),
      this.props.delayInMs
    );
    this.setState({ intervalId });
  };

  finalSubmit(data) {
    const {
      signupData: { BusinessUserDataStep1 }
    } = this.props;

    this.setState(
      {
        file: data.file
      },
      () => {
        this.setState({ errors: {}, isLoading: true });
        if (BusinessUserDataStep1.step1.defaultIndex === 0) {
          this.props.saveConsumerUser(this.state);
        } else {
          this.props.saveBusinessUser(this.state);
        }
      }
    );
  }

  openModal() {
    this.setState({ modalIsOpen: true, fileError: false });
  }

  afterOpenModal() { }

  closeModal() {
    this.setState({ modalIsOpen: false });
  }

  fileChangedHandler = event => {
    this.setState({ file: event.target.files[0] });
  };

  uploadHandler = () => { };

  confirmState() {
    this.setState({ errors: {}, IsCompanyForm: 6 });
  }

  codeOnSubmit(e) {
    e.preventDefault();

    if (this.state.code !== "") {
      this.props.confirmUserEmail(this.state);
    } else {
      const errors = {};
      errors.code = "Verification code is Required";
      this.setState({
        errors
      });
    }
  }

  componentWillUnmount() {
    this.props.clearData();
  }

  componentDidUpdate() {
    const { plansDataAffiliate, userInfo } = this.props.data;

    // const { BusinessUserDataStep1 } = this.props;
    const {
      match: { params },
      signupData: { BusinessUserDataStep1 }
    } = this.props;
    const { BusinessUserDataStep1Data } = this.state;

    const plainDto = {};

    if (BusinessUserDataStep1.step1 !== undefined) {
      if (BusinessUserDataStep1Data !== BusinessUserDataStep1) {
        this.setState({
          BusinessUserDataStep1Data: BusinessUserDataStep1,
          firstName: BusinessUserDataStep1.step1.firstName,
          lastName: BusinessUserDataStep1.step1.lastName,
          signatureDefaultValue:
            BusinessUserDataStep1.step1.signatureDefaultValue,
          companyTitle: BusinessUserDataStep1.step1.companyTitle,
          email: BusinessUserDataStep1.step1.email,
          password: BusinessUserDataStep1.step1.password,
          workPhoneNumber: BusinessUserDataStep1.step1.workPhoneNumber,
          nonWorkPhoneNumber: BusinessUserDataStep1.step1.nonWorkPhoneNumber,
          companyName: BusinessUserDataStep1.step1.companyName,
          acceptCC: BusinessUserDataStep1.step1.acceptCC,
          bankruptcyStatus: BusinessUserDataStep1.step1.bankruptcyStatus,
          dissolvedStatus: BusinessUserDataStep1.step1.dissolvedStatus,
          totalTaxId: BusinessUserDataStep1.step1.totalTaxId,
          streeAddress: BusinessUserDataStep1.step1.streeAddress,
          city: BusinessUserDataStep1.step1.city,
          state: BusinessUserDataStep1.step1.state,
          zipCode: BusinessUserDataStep1.step1.zipCode,
          separateTaxId: BusinessUserDataStep1.step1.separateTaxId,
          enterpriseType: BusinessUserDataStep1.step1.enterpriseType,
          startingYear: BusinessUserDataStep1.step1.startingYear,
          webSite: BusinessUserDataStep1.step1.webSite,
          industryTypeId: BusinessUserDataStep1.step1.industryTypeId,
          taxId: BusinessUserDataStep1.step1.taxId,
          planPriceId: BusinessUserDataStep1.step1.planPriceId,
          readDisclaimer: BusinessUserDataStep1.step1.readDisclaimer,
          readPrivacyPolicy: BusinessUserDataStep1.step1.readPrivacyPolicy,
          readLetterOfAgency: BusinessUserDataStep1.step1.readLetterOfAgency,
          readUserAgreement: BusinessUserDataStep1.step1.readUserAgreement,
          defaultIndex: BusinessUserDataStep1.step1.defaultIndex,

          cFirstName: BusinessUserDataStep1.step1.cFirstName,
          cLastName: BusinessUserDataStep1.step1.cLastName,
          cState: BusinessUserDataStep1.step1.cState,
          cSince: BusinessUserDataStep1.step1.cSince,
          cEmployer: BusinessUserDataStep1.step1.cEmployer,
          cEmail: BusinessUserDataStep1.step1.cEmail,
          cPhone: BusinessUserDataStep1.step1.cPhone,
          cPassword: BusinessUserDataStep1.step1.cPassword,
          cNotification: BusinessUserDataStep1.step1.cNotification,
          cUpdateClaim: BusinessUserDataStep1.step1.cUpdateClaim,
          serviceFeeAgree: BusinessUserDataStep1.step1.serviceFeeAgree,
          bankAccount: BusinessUserDataStep1.step1.bankAccount,
          otherIndustryType: BusinessUserDataStep1.step1.otherIndustryType,

          caffiliateId: BusinessUserDataStep1.step1.caffiliateId,
          caffiliateKey: BusinessUserDataStep1.step1.caffiliateKey,

          affiliateId: BusinessUserDataStep1.step1.affiliateId,
          affiliateKeyId: BusinessUserDataStep1.step1.affiliateKeyId,
          selectedPlanName: BusinessUserDataStep1.step1.selectedPlanName,
          selectedPlanAmount: BusinessUserDataStep1.step1.selectedPlanAmount,
          paymentStatus: BusinessUserDataStep1.step1.paymentStatus,

          cRoleName: BusinessUserDataStep1.step1.cRoleName,
          roleName: BusinessUserDataStep1.step1.roleName

          // showTab: 2,
          // IsCompanyForm: 2,
        });
      }
    }

    const { plansDataAffiliate1, userDataLogin1 } = this.state;
    if (userInfo !== undefined) {
      if (typeof userInfo.user !== "undefined") {
        if (userDataLogin1 !== userInfo) {
          this.setState({
            userDataLogin1: userInfo
          });
          // If the fusebill payment status is paid.
          if (localStorage.getItem("paymentStatus") === "paid") {
            this.context.router.history.push("/dashboard");
          }
        }
      }
    }

    if (plansDataAffiliate !== undefined) {
      if (params.affiliateKey !== undefined) {
        if (plansDataAffiliate.result !== undefined) {
          if (plansDataAffiliate.result.affiliateActive === 1) {
            if (plansDataAffiliate1 !== plansDataAffiliate) {
              Object.assign(plainDto, {
                records: plansDataAffiliate.result.affiliateSubscriptionDto.map
              });
              this.setState({
                plansDataAffiliate1: plansDataAffiliate,
                AllPlansForMember1: plainDto,
                affiliateId: plansDataAffiliate.result.userId,
                isLoader: false
              });
              if (plansDataAffiliate.result.affiliateType === "Both") {
                this.setState({
                  IsCompanyForm: 1,
                  defaultIndex: 1
                });
              } else if (
                plansDataAffiliate.result.affiliateType === "Business"
              ) {
                this.setState({
                  IsCompanyForm: 1,
                  defaultIndex: 1,
                  showTab: 2,
                  indicatorBusiness: "active",
                  indicatorConsumer: ""
                });
              } else if (
                plansDataAffiliate.result.affiliateType === "Consumer"
              ) {
                this.setState({
                  defaultIndex: 0,
                  showTab: 2,
                  indicatorBusiness: "",
                  indicatorConsumer: "active"
                });
              }
              this.props.getAllPlans({
                pageNumber: 0,
                pageSize: 20,
                searchKeyword: "",
                planUserType: "Business",
                userId:
                  plansDataAffiliate.result.userId !== undefined
                    ? plansDataAffiliate.result.userId
                    : 0,
                affiliateKey:
                  this.props.match.params.affiliateKey !== undefined
                    ? this.props.match.params.affiliateKey
                    : ""
              });
            }
          } else {
            this.context.router.history.push("/signup-disabled");
          }
        }
      }
    }
  }

  AfterLogin() {
    if (!this.state.isLoginCheck) {
      Auth.signIn(this.state.cEmail.toLowerCase(), this.state.cPassword)
        .then(user => {
          const jwtToken = user.signInUserSession.accessToken.jwtToken;
          const postInfo = {
            email: this.state.cEmail.toLowerCase(),
            token: jwtToken,
            user
          };
          this.props.requestApiData(postInfo);
          this.setState({ isLoginCheck: true });
          // setTimeout(() => { ; }, 1000);
        })
        .catch(error => {
          this.setState({ isLoginCheck: false, isLoading: false });
          this.setState({ failedLoginMessages: error.message });
          // if (error.message === 'User is not confirmed.') {
          //   this.context.router.history.push('/verify-code');
          // }
        });
    }
  }

  async componentWillReceiveProps(nextProps) {
    let errors = {};
    errors = this.state.errors;
    const { BusinessUserData, RecieveConsumerUserData } = nextProps.data;
    const isOk = nextProps.data.ConfirmUserEmailData;

    if (typeof RecieveConsumerUserData !== "undefined") {
      this.AfterLogin();
    }

    const isemailVerified = nextProps.data.emailVerifyData
      ? nextProps.data.emailVerifyData
      : {};
    if (Object.keys(isemailVerified).length > 0) {
      if (isemailVerified.collectMessage !== undefined) {
        if (
          isemailVerified.collectMessage.messageShort ===
          "User email already exist"
        ) {
          errors.email =
            "This user's email address has already been added to Collectively";
          this.setState({
            isDisable: true,
            errors
          });
        }
      }
    }
    if (typeof BusinessUserData !== "undefined") {
      if (!this.state.isLoginCheckS) {
        Auth.signIn(this.state.email.toLowerCase(), this.state.password)
          .then(user => {
            const jwtToken = user.signInUserSession.accessToken.jwtToken;
            const postInfo = {
              email: this.state.email.toLowerCase(),
              token: jwtToken,
              user
            };
            this.props.requestApiData(postInfo);
            this.setState({ isLoginCheckS: true });
            // this.context.router.history.push('/dashboard');
            // setTimeout(() => { this.props.history.push('/'); }, 1000);
          })
          .catch(error => {
            this.setState({ failedLoginMessages: error.message });
            this.setState({ isLoginCheckS: false });
            if (error.message === "User is not confirmed.") {
              this.context.router.history.push("/verify-code");
            }
          });
      }
    }
    if (isOk.code === 400) {
      this.setState({
        errorForcodeverify: true
      });
    }

    // Hit API for saving the Fusebill customer ID in DB---------
    if (
      nextProps.data.userInfo.roleName === "Business-User" &&
      nextProps.data.userInfo.userObject.planDto.planName !== "Basic" &&
      nextProps.data.userInfo.userObject.planDto.planName !==
      "Basic Automatic" &&
      nextProps.data.userInfo.userObject.planPriceDtos.connectFusebill !== 0
    ) {
      this.context.router.history.push("/add-payment-method");
    }
  }

  verifyEmail() {
    if (this.state.email !== "") {
      this.props.checkEmailVerify({ email: this.state.email });
    }
  }

  render() {
    const {
      errors,
      isLoading,
      IsCompanyForm,
      signatureDefaultValue,
      signatureFontFamily,
      code,
      isLoader,
      errorForcodeverify
    } = this.state;
    const { AllStates, IndustryData } = this.props.data;

    let loader1;
    if (isLoader) {
      loader1 = (
        <div className="loader">
          <img src={loader} alt="" />
        </div>
      );
    }

    const options = [];
    options.push(
      <option selected disabled key={0} value="">
        State
      </option>
    );
    AllStates.map(item =>
      // return options.push({value: item.stateId, label: item.stateName, name: item.stateName})
      options.push(
        <option key={item.stateId} value={item.stateId}>
          {item.stateName}
        </option>
      )
    );

    const IndustryDataoptions = [];
    IndustryDataoptions.push({
      value: "",
      label: "Industry",
      name: "Industry"
    });
    if (IndustryData !== undefined) {
      if (IndustryData.code !== 400) {
        IndustryData.map(item =>
          IndustryDataoptions.push({
            value: item.lookupTypeValueId,
            label: item.displayText,
            name: item.displayText
          })
        );
      }
    }
    const optionsSince = [];
    optionsSince.push({
      value: "",
      label: "Year your business started",
      name: "Since"
    });
    optionsSince.push({
      value: "Prior to 1990",
      label: "Prior to 1990",
      name: "Since"
    });

    const currentDate = new Date().getFullYear();
    for (let i = 1990; i <= currentDate; i++) {
      optionsSince.push({ value: i.toString(), label: i, name: i });
    }

    return (
      <span>
        {loader1}
        {isLoader === false ? (
          <div className="container">
            <div className="main-content">
              <Header />
              <div className="white-box">
                <div className="section-content create-account">
                  <div className="row">
                    <div className="col s12 m10 offset-m1">
                      <div className="row">
                        <div className="col s12 m6 create-acc-hdr">
                          <h5> Create Account </h5>
                        </div>
                        <div className="col s12 m6 already-acc">
                          <Link to="/">Already have an account?</Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="section-content left-align create-signature">
                  <SignatureComponent
                    defaultValue={signatureDefaultValue}
                    fontFamily={signatureFontFamily}
                    signBack={this.backClick}
                    finalSubmitData={this.finalSubmit}
                    loader={isLoading}
                    moveTop={this.topScreen}
                    hide
                  />
                </div>

                <div
                  className={
                    IsCompanyForm === 6
                      ? "section-content center-align login-content"
                      : "hide"
                  }
                >
                  <h2>Confirm Account</h2>
                  <p>Enter the Code recived on registered email and submit.</p>

                  <div className="row">
                    <form
                      className="col s8 offset-s2"
                      onSubmit={this.codeOnSubmit}
                    >
                      <div className="row">
                        <div className="input-field col s12">
                          <TextFieldGroup
                            field="code"
                            label="Code"
                            value={code}
                            error={errors.code}
                            onChange={this.onChange}
                          />
                        </div>
                        <span
                          className={
                            errorForcodeverify ? "show invalid" : "hide"
                          }
                        >
                          code is not valid.
                        </span>
                        <div className="col s12">
                          <button
                            className="btn waves-effect waves-light primary-btn col s12"
                            type="submit"
                            name="action"
                          >
                            Confirm
                            <i className="material-icons">arrow_forward</i>
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
            ""
          )}
      </span>
    );
  }
}

Signup.contextTypes = {
  router: PropTypes.object.isRequired
};
const mapStateToProps = state => ({
  data: state.data,
  signupData: state.signupData
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      saveBusinessUser,
      saveConsumerUser,
      saveBusinessUserStep1,
      getAllCountry,
      getAllStates,
      getCityByStateId,
      getAffiliateDetailByAffiliateKey,
      getAllPlans,
      confirmUserEmail,
      clearData,
      getIndustry,
      getBusiness,
      checkEmailVerify,
      requestApiData,
      getPageData,
      clearDataEmail
    },
    dispatch
  );
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Signup)
);
